// Input validation utilities

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  // Remove spaces, dashes, parentheses, plus signs for validation
  const cleaned = phone.replace(/[\s\-\(\)\+]/g, '');
  // Should be 8-15 digits
  return /^\d{8,15}$/.test(cleaned);
};

export const sanitizeInput = (input, maxLength = 255) => {
  if (typeof input !== 'string') return '';
  // Remove script tags and dangerous HTML
  let sanitized = input
    .replace(/<script[^>]*>.*?<\/script>/gi, '')
    .replace(/<iframe[^>]*>.*?<\/iframe>/gi, '')
    .replace(/javascript:/gi, '')
    .replace(/on\w+\s*=/gi, '');
  
  // Limit length
  if (sanitized.length > maxLength) {
    sanitized = sanitized.substring(0, maxLength);
  }
  
  return sanitized.trim();
};

export const validateQuantity = (quantity) => {
  // Must be positive integer between 1 and 100
  const num = Number(quantity);
  return Number.isInteger(num) && num >= 1 && num <= 100;
};

export const validatePrice = (price) => {
  // Must be positive number
  const num = Number(price);
  return !isNaN(num) && num > 0 && num < 1000000; // Max 1 million
};

export const validateName = (name, maxLength = 255) => {
  if (!name || typeof name !== 'string') return false;
  const sanitized = sanitizeInput(name, maxLength);
  return sanitized.length >= 1 && sanitized.length <= maxLength;
};

export const validateAddress = (address, maxLength = 500) => {
  if (!address || typeof address !== 'string') return false;
  const sanitized = sanitizeInput(address, maxLength);
  return sanitized.length >= 1 && sanitized.length <= maxLength;
};

export const validateRequired = (value) => {
  return value !== null && value !== undefined && String(value).trim().length > 0;
};

// Validate entire checkout form
export const validateCheckoutForm = (formData) => {
  const errors = {};

  if (!validateRequired(formData.firstName)) {
    errors.firstName = 'First name is required';
  } else if (!validateName(formData.firstName, 100)) {
    errors.firstName = 'First name must be between 1 and 100 characters';
  }

  if (!validateRequired(formData.lastName)) {
    errors.lastName = 'Last name is required';
  } else if (!validateName(formData.lastName, 100)) {
    errors.lastName = 'Last name must be between 1 and 100 characters';
  }

  if (!validateRequired(formData.email)) {
    errors.email = 'Email is required';
  } else if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (!validateRequired(formData.phone)) {
    errors.phone = 'Phone number is required';
  } else if (!validatePhone(formData.phone)) {
    errors.phone = 'Please enter a valid phone number (8-15 digits)';
  }

  if (!validateRequired(formData.shippingMethod)) {
    errors.shippingMethod = 'City is required';
  }

  if (!validateRequired(formData.buildingNumber)) {
    errors.buildingNumber = 'Building number is required';
  }

  if (!validateRequired(formData.streetNumber)) {
    errors.streetNumber = 'Street number is required';
  }

  if (!validateRequired(formData.zoneNumber)) {
    errors.zoneNumber = 'Zone number is required';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};





